import { FC } from "react";

const Tram: FC = () => {
    return (
        <>
            <div className="fs-16 fw-700 text-black">Tram</div>
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M16.25 6.25L17.1875 4.375H21.25V2.5H8.75V4.375H14.6875L13.75 6.25C9.8375 6.3625 6.25 7.1625 6.25 10.625V21.25C6.25 23.125 7.6375 24.6625 9.4375 24.9375L7.5 26.875V27.5H10L12.5 25H17.5L20 27.5H22.5V26.875L20.5625 24.9375C22.3625 24.6625 23.75 23.125 23.75 21.25V10.625C23.75 7.1625 20.1625 6.3625 16.25 6.25ZM13.7875 8.75H16.2125C19.65 8.85 20.7375 9.475 21.0875 10H8.9125C9.2625 9.475 10.35 8.85 13.7875 8.75ZM13.5625 22.4375H9.675C9.125 22.3 8.75 21.8125 8.75 21.25V20H13.6125C13.3125 20.3375 13.125 20.7625 13.125 21.25C13.125 21.7 13.2875 22.1125 13.5625 22.4375ZM21.25 21.25C21.25 21.8125 20.875 22.3 20.325 22.4375H16.4375C16.7125 22.1125 16.875 21.7 16.875 21.25C16.875 20.7625 16.6875 20.3375 16.3875 20H21.25V21.25ZM21.25 17.5H8.75V12.5H21.25V17.5Z"
                fill="black"
                />
            </svg>
        </>
    )
}

export default Tram;